import axios from "axios";
import { API_BASE } from "@/lib/apiBase";
import { getAuthRedirectPath } from "@/lib/adminRoute";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Interceptor para tratar 401 globalmente
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401 && !error.config?.suppressAuthRedirect) {
      localStorage.removeItem("admin_session");
      try { await axios.post(`${API_BASE}/logout`, {}, { withCredentials: true }); } catch (_) {}
      window.location.replace(getAuthRedirectPath());
    }
    return Promise.reject(error);
  }
);

export default api;
